import { FC, ReactNode } from 'react';
import PropTypes from 'prop-types';
import { Box, Container, styled } from '@mui/material';

const PageTitle = styled(Box)(
  ({ theme }) => `
        padding-top: ${theme.spacing(1)};
        padding-bottom: ${theme.spacing(1)};
`
);

interface PageTitleWrapperProps {
  children?: ReactNode;
}

const PageTitleWrapper: FC<PageTitleWrapperProps> = ({ children }) => {
  return (
    <PageTitle className="MuiPageTitle-wrapper">
      <Container
        disableGutters
        maxWidth={false}
        sx={{
          maxWidth: { xs: '100%', md: '95%' },
          ml: { xs: 0, md: 5 },
          px: 2,
          // Long titles wrap instead of running off a phone screen.
          overflowWrap: 'anywhere'
        }}
      >
        {children}
      </Container>
    </PageTitle>
  );
};

PageTitleWrapper.propTypes = {
  children: PropTypes.node.isRequired
};

export default PageTitleWrapper;
